<template>
  <div class="layout-col white-space-normal ">
    <section class="-wrapper-tile -wrapper-column -h-center- -height-100">
      <div class="-header between- -pl-4 -pr-2">
        <p class="-h2 -font-weight-regular">
          <span class="-wrapper-v-center -font-size-14 -font-weight-medium">
            <img :src="serviceInfo.logoUrl" :alt="serviceInfo.name" />&nbsp;
            <g-icon tag="i" name="ci-icon-alm" size="medium" class="-mr-1"></g-icon>{{ serviceInfo.name }}
          </span>
        </p>
        <g-button id="dashboard-service-card1-open" variant="borderless" size="small" class="-px-1 -mr-0" @click="goToService">
          <g-icon name="navigate_next"></g-icon>
        </g-button>
      </div>
      <div class="-width-100 -pt-4 -pl-5 -pr-5 -pb-5">
        <p class="-font-size-12 -font-weight-bold">{{serviceInfo.summary}}</p>
        <div v-if="serviceInfo.features.length > 0" class="-wrapper-column -mt-2">
          <p v-for="(feature, id) in serviceInfo.features" :key="id" class="-font-size-12 -paragraph">- {{feature}}</p>
        </div>
        <button id="dashboard-service-card1-move" class="-btn primary- small- -mt-5" type="button" onclick="goToSupport">
          <span>{{ $t('pages_dashboard_opsnow_service.request') }}</span>
        </button>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'service-intro-card',
  componentName: 'ServiceIntroCard',
  props: {
    serviceInfo: {
      type: Object,
      default: () => {
        return {
          logoUrl: '',
          name: '',
          href: '',
          supportUrl: '',
          summary: '',
          features: []
        }
      }
    }
  },
  methods: {
    goToService () {
      if (!!this.serviceInfo.href){
        window.location.href = this.serviceInfo.href
      }
    },
    goToSupport () {
      window.open(this.serviceInfo.supportUrl)
    }
  },
  mounted () {
    console.log(this.serviceInfo)
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/home/components/ServiceIntroCard.vue